import React from 'react';

export default function Divider(){
return(
    <div className='divider'></div>
)
}